import { Link as ReactRouterLink } from 'react-router-dom';


const ClickableItem = ReactRouterLink;

export default ClickableItem;
